$(function () {
    $('#student_select').select2({
        width: '100%',          
        placeholder: 'Search for a student',
        allowClear: true,
        ajax: {
            url: '/estudent/students/autocomplete',
            dataType: 'json',
            delay: 250, // Delay in milliseconds to debounce requests
            data: function (params) {
                return {
                    // Search term
                    query: params.term
                };
            },
            processResults: function (data) {
                return {
                    results: data.map(item => ({
                        id: item.id,
                        text: item.text,
                        type: item.type
                    }))
                };
            }
        },
        // Minimum characters before triggering search
        minimumInputLength: 3,

        templateSelection: function (data) {
            if (!data.id) return data.text;
            
            $('#estudent_service_request_payable_type').val(data.type);
            return data.text;
        }
    });

    $(document).on('select2:open', () => {
        document.querySelector('.select2-search__field').focus();
    });
});